// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1jN4W","question":"Question_question__2VwuG","description":"Question_description___ppXQ"};